import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { css } from "glamor";

const tabStyle = css({
    " .MuiTabs-root": {
        alignSelf: "left",
        borderBottom: "2px solid #F0F0F0",
    },
    " .MuiTab-root": {
        color: "gray",
        fontSize: "14px",
        transition: "none",
        padding: "10px 20px",
        textTransform: "capitalize",
    },
    " .Mui-selected": {
        color: "#00B0F0",
    },
    " .MuiTab-wrapper": {
        transition: "none",
    },
    " .MuiTab-wrapper:focus": {
        color: "#00B0F0",
    },
    " .MuiTabs-indicator": {
        backgroundColor: "#00B0F0",
    },
});

const Pane = ({ children, isVisible }) => {
    if (!isVisible) return null;
    return <div style={{ display: "flex", justifyContent: "flex-end" }}>{children}</div>;
};

function FormattedTabs(props) {
    const [value, setValue] = useState(props.defaultActiveKey);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (props.onChange) {
            props.onChange(newValue)
        }
    };

    return (
        <Box className={`${tabStyle}`} sx={{ alignSelf: 'left' }}>

            <div style={{ position: 'relative', width: '100%' }}>
                <Box
                    sx={{
                        position: 'absolute', // Place the second Box above the Tabs
                        top: 5,
                        right: 0,
                        mb: -1,
                        zIndex: 1, // Ensure it stays above the Tabs
                    }}
                >
                    {props.tabPanes.map((paneInfo) => (
                        <Pane key={paneInfo.key} isVisible={paneInfo.key === value}>
                            {paneInfo?.actionBtn?.props?.children}
                        </Pane>
                    ))}
                </Box>
                <Box>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            width: '100%',
                            mb: 2,
                            '.MuiTabs-scroller': {
                                width: '100%',
                            },
                        }}
                    >
                        {props.tabPanes.map((paneInfo) => (
                            <Tab
                                label={paneInfo.title}
                                key={paneInfo.key}
                                disabled={paneInfo.disabled}
                            />
                        ))}
                    </Tabs>
                </Box>
            </div>
            {props.tabPanes.map((paneInfo, index) => (
                <Box
                    sx={paneInfo.sx}
                    key={paneInfo.key}
                    hidden={value !== paneInfo.key}
                >
                    {paneInfo.body}
                </Box>
            ))}
        </Box>
    );
}

export default FormattedTabs;
